import type { CartOrderType } from "@shared/types/Cart";

export const filterByWarehouse = (products: any[], warehouseId: number) =>
    products?.filter(p => p.warehouse_id === warehouseId);

export function splitByWarehouse(order: CartOrderType) {
  let warehouses = [];
  let warehouseCollection = {};
  order.products.forEach(product => {
    if (!warehouseCollection[product.warehouse_id]) {
      warehouseCollection[product.warehouse_id] = 1;
      const warehouseName = product.warehouse_id ? product.warehouse_name : "Delivery";

      const { total, subtotal } = orderTotalAndSubtotalForWarehouse(product.warehouse_id, order);

      warehouses.push({
        id: product.warehouse_id,
        name: warehouseName,
        total,
        subtotal,
      });
    }
  });

  warehouses.sort((a, b) => {
    if (a.id === null) {
      return -1000;
    }
    return a.name - b.name;
  });
  return warehouses;
}

const findOrderTotalsForWarehouse = (warehouseId: number, order: CartOrderType) => {
  return order.order_totals_by_warehouse?.find(
    order_total => order_total.warehouse_id == warehouseId
  );
};

const orderTotalAndSubtotalForWarehouse = (warehouseId: number, order: CartOrderType) => {
  const orderTotalsForWarehouse = findOrderTotalsForWarehouse(warehouseId, order);
  return {
    total: orderTotalsForWarehouse?.total || order.total,
    subtotal: orderTotalsForWarehouse?.subtotal || order.subtotal,
  };
};